module.exports = __webpack_public_path__ + "static/media/banner-thumb-1.b3724ebf.png";